import React, { useState } from 'react';
import Button from '../Button/Button';
import './PassationModal.css';

interface PassationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (idGestionnaireSortant: number) => Promise<void>;
  gestionnairesActifs: Array<{
    id: number;
    nom: string;
    prenom: string;
    email_contact: string;
  }>;
  nouveauGestionnaire: {
    nom: string;
    prenom: string;
  };
}

const PassationModal: React.FC<PassationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  gestionnairesActifs,
  nouveauGestionnaire
}) => {
  const [selectedGestionnaire, setSelectedGestionnaire] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    if (!selectedGestionnaire) {
      setError('Veuillez sélectionner un gestionnaire sortant');
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      await onConfirm(parseInt(selectedGestionnaire));
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Une erreur est survenue');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="passation-modal-overlay" onClick={onClose}>
      <div className="passation-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="passation-modal-header">
          <h2>Limite de gestionnaires atteinte (3/3)</h2>
          <button className="passation-modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="passation-modal-body">
          <div className="passation-info-box">
            <p className="passation-info-text">
              <strong>ℹ️ Information importante</strong><br />
              Pour promouvoir <strong>{nouveauGestionnaire.prenom} {nouveauGestionnaire.nom}</strong> en gestionnaire,
              vous devez sélectionner un gestionnaire actuel qui sera remplacé après validation.
            </p>
          </div>

          <div className="passation-form-group">
            <label htmlFor="gestionnaire-sortant">
              Sélectionner le gestionnaire à remplacer <span className="required">*</span>
            </label>
            <select
              id="gestionnaire-sortant"
              className="passation-select"
              value={selectedGestionnaire}
              onChange={(e) => setSelectedGestionnaire(e.target.value)}
              disabled={isLoading}
            >
              <option value="">-- Choisir un gestionnaire --</option>
              {gestionnairesActifs.map((gestionnaire) => (
                <option key={gestionnaire.id} value={gestionnaire.id}>
                  {gestionnaire.prenom} {gestionnaire.nom} ({gestionnaire.email_contact})
                </option>
              ))}
            </select>
          </div>

          <div className="passation-warning-box">
            <p className="passation-warning-text">
              ⚠️ <strong>Attention :</strong> Un email sera envoyé au gestionnaire sélectionné pour valider ce changement.
              Le gestionnaire actuel restera en fonction tant que la passation n'aura pas été validée.
            </p>
          </div>

          {error && (
            <div className="passation-error-box">
              <p className="passation-error-text">❌ {error}</p>
            </div>
          )}
        </div>

        <div className="passation-modal-footer">
          <Button
            value="Annuler"
            variant="secondary"
            onClick={onClose}
            disabled={isLoading}
          />
          <Button
            value={isLoading ? "Envoi en cours..." : "Demander la passation"}
            variant="primary"
            onClick={handleConfirm}
            disabled={isLoading || !selectedGestionnaire}
          />
        </div>
      </div>
    </div>
  );
};

export default PassationModal;
